module.exports = __webpack_public_path__ + "static/media/room4.d6db5312.jpg";